<template>
  <Modal title="查看上课情况" v-model="visible" width="815">
    <Table class="compact" size="small" :columns="column" :data="dataList"></Table>
    <div slot="footer" ></div>
  </Modal>
</template>
<script>
  export default {
    name: 'ClassMemberTimeModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      openedId: {
        type: Number
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      let $moment = this.$moment
      return {
        visible: this.value,
        dataList: [],
        column: [
          {
            title: '老师进教室时间',
            width: 135,
            align: 'center',
            render: (h, params) => {
              if (params.row.tchStartTime === 0) {
                return h('span', '')
              }
              return h('span', $moment(params.row.tchStartTime, 'X').format('YYYY-MM-DD HH:mm:ss'))
            }
          },
          {
            title: '老师最后出教室时间',
            width: 135,
            align: 'center',
            render: (h, params) => {
              if (params.row.tchEndTime === 0) {
                return h('span', '')
              }
              return h('span', $moment(params.row.tchEndTime, 'X').format('YYYY-MM-DD HH:mm:ss'))
            }
          },
          {
            title: '学生进教室时间',
            width: 135,
            align: 'center',
            render: (h, params) => {
              if (params.row.sdStartTime === 0) {
                return h('span', '')
              }
              return h('span', $moment(params.row.sdStartTime, 'X').format('YYYY-MM-DD HH:mm:ss'))
            }
          },
          {
            title: '学生出教室时间',
            width: 135,
            align: 'center',
            render: (h, params) => {
              if (params.row.sdEndTime === 0) {
                return h('span', '')
              }
              return h('span', $moment(params.row.sdEndTime, 'X').format('YYYY-MM-DD HH:mm:ss'))
            }
          },
          {
            title: '老师在教室时间(秒)',
            width: 120,
            align: 'center',
            render: (h, params) => {
              if (params.row.tchTime === 0) {
                return h('span', '')
              }
              return h('span', params.row.tchTime)
            }
          },
          {
            title: '学生在教室时间(秒)',
            width: 121,
            align: 'center',
            render: (h, params) => {
              if (params.row.sdTime === 0) {
                return h('span', '')
              }
              return h('span', params.row.sdTime)
            }
          },
        ]
      }
    },
    methods: {
      onLoad () {
        let self = this
        let loadMsg = this.$Message.loading('正在加载中...', 0)
        self.$http.get('/bookLesson/getClassMemberTime', { params: {lsnOpenId: self.openedId} }).then(function (res) {
          loadMsg()
          if (!res || !res.data) {
            self.$emit('on-close')
            return
          }
          self.dataList = [res.data]
          self.visible = true
        })
      }
    },
    watch: {
      value (val) {
        if (val === true) {
          this.onLoad()
        } else {
          this.visible = val
        }
      },
      visible (val) {
        this.$emit('input', val)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ClassMemberTimeModal.vue?1dcffeb2